import * as Yup from 'yup';
import React, { useState, useEffect } from "react"
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './custom.css'
import Iconify from '../Iconify';
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { LoadingButton } from '@mui/lab';
import { Button, Stack, IconButton, InputAdornment, Box, TextField } from '@mui/material';
import { Link, useNavigate } from "react-router-dom"
import { login } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
import { custome } from '../../api/custome';
// -------------------------------------------------

const Custom = () => {
  const navigate = useNavigate()
  const [showError, setShowError] = useState();
  const [showLoader, setShowLoader] = useState();
  const notify = (message) => toast(message)
  const LoginSchema = Yup.object().shape({
    query: Yup.string().required('Message is Required'),
  });

  const defaultValues = {
    query: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    setValue,
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    console.log(data)
    try {
      const response = await custome(data)
      if (response.code === 200) {
        notify(response.message)
        reset()
      } else {
        notify(response.message)
        reset()
      }
    } catch (error) {
      notify(error.message)
      reset()
    }
    setShowLoader(false)
  };

  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-9'>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 5px rgba(16, 16, 16, .09)',
                  p: 2,
                  borderRadius: '25px',
                }}
              >
                <div className='row'>
                  <div className='col-md-6'>
                    <img src='../images/signin.svg' />
                  </div>
                  <div className='col-md-6'>
                    <div className='accountSection'>
                      <img src='../images/logo.jpg' />
                      <h3>For More Complex Booking</h3>
                      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField
                            name="query"
                            multiline
                            rows={4}
                            placeholder="Type your message here"
                            spellCheck
                          />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <LoadingButton
                            fullWidth size="large" type="submit" className='signBtn' loading={isSubmitting}>
                            Submit
                          </LoadingButton>
                        </Stack>
                      </FormProvider>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Custom
